import { useMutation } from 'Data/Api.js'
import { notifyError, useNotifications } from 'Logic/Notifications.js'
import { useDataSubmit, useDataValue } from 'Simple/Data.js'

import mutationRequirementsCheck from './mutation-requirements-check.graphql.js'

/** @type {import('Simple/types.js').useDataOnSubmit} */
export default function useDataOnSubmit(props) {
  let id = useDataValue({
    context: 'appointment_actions',
    path: 'appointment_booking.id',
    viewPath: props.viewPath,
  })

  let submit = useDataSubmit({
    context: 'appointment_actions',
    viewPath: props.viewPath,
  })

  let [, executeMutationRequirementsCheck] = useMutation(
    mutationRequirementsCheck
  )
  let [, notify] = useNotifications()

  return async function onSubmit({ args }) {
    if (!args?.skip_required_fields) {
      let mutationRequirementsCheckResponse =
        await executeMutationRequirementsCheck({
          id,
          params: { id, skip_required_fields: false },
        })
      if (mutationRequirementsCheckResponse.error) {
        notify(
          notifyError('Cannot unseat selected appointment. Please try again.')
        )
        return false
      }

      if (
        mutationRequirementsCheckResponse.data
          .create_pre_appointment_bookings_state_update_automations.is_pending
      ) {
        // cannot unseat yet as some requirements need to be checked
        return false
      }
    }

    return submit({
      type: 'unseat',
      skip_required_fields: args?.skip_required_fields || false,
    })
  }
}
